import type { ExtendedStatuses } from '@metmuseum/types';

// TODO: put this in a shared utils package or something
export const EXTENDED_STATUSES: ExtendedStatuses = {
	ACCESSIONED: 'accessioned',
	DEACCESSIONED_NOT_YET_RESTITUTED: 'deaccessioned_not_yet_restituted',
	DEPARTMENT_LOAN: 'department_loan',
	EXHIBITION_LOAN: 'exhibition_loan',
	LAUDER_CUBIST_COLLECTION: 'lauder_cubist_collection',
	NON_ACCESSIONED: 'non_accessioned',
	PROMISED_GIFT: 'promised_gift',
	RESTITUTED: 'restituted',
	RETURNED_LOAN: 'returned_loan',
	RETURNED_TO_LENDER_NOT_RESTITUTED: 'returned_to_lender_not_restituted',
	UNACCESSIONED: 'unaccessioned',
	UNASSIGNED: 'unassigned',
};

// Statuses that must NOT surface as related artwork. Distinct from the search
// page's de-boost list in build-query.ts: that one down-weights loan statuses
// too, but related-artwork explicitly keeps on-loan objects visible.
export const EXCLUDE_FROM_RELATED_STATUSES: readonly string[] = [
	EXTENDED_STATUSES.RESTITUTED,
	EXTENDED_STATUSES.DEACCESSIONED_NOT_YET_RESTITUTED,
	EXTENDED_STATUSES.NON_ACCESSIONED,
	EXTENDED_STATUSES.UNACCESSIONED,
	EXTENDED_STATUSES.UNASSIGNED,
];
